// extracted by mini-css-extract-plugin
export var chevronIcon = "_5k-2";
export var teamName = "_5k-1";
export var teamSwitcherButton = "_5k-0";